import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { firebaseConnect, isLoaded } from 'react-redux-firebase';

import './CompanyList.css';

import LoadingSpinner from 'components/global/LoadingSpinner/LoadingSpinner';
import CompanyListItem from '../CompanyListItem/CompanyListItem';

class CompanyList extends React.Component {
  static propTypes = {
    companies: PropTypes.object
  };

  render() {
    const { companies } = this.props;

    return (
      <div className='CompanyList-root'>
        {
          !isLoaded(companies) ? 
          <div className='CompanyList-loadingContainer'>
            <LoadingSpinner />
          </div> :
          <ul className='CompanyList-list'>
            <p>Select a company below</p>
            <hr />
            <CompanyListItem
              name='Create a new Company'
              logo=''
              profileType=''
              to={'/companyform?company=new'}
            />
            {
              Object.keys(companies).sort().map(companyKey => (
                <CompanyListItem 
                  key={companyKey}
                  name={companies[companyKey].name}
                  logo={companies[companyKey].logo}
                  size={companies[companyKey].size}
                  industry={companies[companyKey].industry}
                  status={companies[companyKey].status}
                  to={`/companyform?company=${companyKey}`}
                />
              ))
            }
          </ul>
        }
      </div>
    );
  }
}

const connectedCompanyList = connect(
  (state, props) => ({
    companies: state.firebase.data.company
  })
)(CompanyList);

const wrappedCompanyList = firebaseConnect([
  { path: '/company' }
])(connectedCompanyList);

export default wrappedCompanyList;



// WEBPACK FOOTER //
// ./src/components/companies/CompanyList/CompanyList.js